import { render, staticRenderFns } from "./CommonWidget.vue?vue&type=template&id=39161e52&"
import script from "./CommonWidget.vue?vue&type=script&lang=js&"
export * from "./CommonWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports